




































































































































































































































































































import {Component, Prop, Watch} from 'vue-property-decorator'
import {TextHelper} from '@/helpers/TextHelper'
import {MixinScreenSize} from '@/components/mixins/MixinScreenSize'

export type OrbitClaimBarItem = {
  tokenImage: string
  tokenSymbol: string
  totalAmount: number
}

@Component({
  computed: {
    TextHelper() {
      return TextHelper
    },
  },
})
export default class OrbitClaimBar extends MixinScreenSize {
  @Prop({type: Array, required: true})
  items!: OrbitClaimBarItem[]

  @Prop({type: Boolean, default: false})
  isDisabled!: boolean

  @Prop({type: Boolean, default: false})
  allClaimed!: boolean

  @Prop({type: String, default: undefined})
  disabledTitle!: string | undefined

  @Prop({type: Boolean, default: false})
  isExpired!: boolean

  page = 0

  get pageSize() {
    if (this.isMobileS) {
      return 1
    } else if (this.isMobileM || this.isMobileL) {
      return 2
    } else if (this.isTablet) {
      return 4
    } else if (this.isLessThanTablet) {
      return 2
    } else if (this.isLargeDesktop) {
      return 5
    } else if (this.isSmallDesktop || this.isDesktop) {
      return 3
    }

    return 5
  }

  get totalPages() {
    return Math.max(1, Math.ceil(this.items.length / this.pageSize))
  }

  get canPrev() {
    return this.page > 0
  }

  get canNext() {
    return this.page < this.totalPages - 1
  }

  get pagedTokens() {
    const start = this.page * this.pageSize
    return this.items.slice(start, start + this.pageSize)
  }

  get pagedTokensToShow() {
    return this.pagedTokens
  }

  get remainingCount() {
    const shown = (this.page + 1) * this.pageSize
    return Math.max(0, this.items.length - shown)
  }

  nextPage() {
    if (this.canNext) this.page += 1
  }

  prevPage() {
    if (this.canPrev) this.page -= 1
  }

  @Watch('items', {deep: true})
  onDataChange() {
    if (this.page > this.totalPages - 1) {
      this.page = Math.max(0, this.totalPages - 1)
    }
  }
}
